import { createContext } from "react"

export const TableRowContext = createContext<{
  interactive?: boolean
}>({
  interactive: false,
})
